/** Calendar UI strings for non-English locales. */

export const CALENDAR_LOCALE_BLOCKS = {
  hi: {
    title: "कैलेंडर",
    today: "आज",
    month: "महीना",
    week: "सप्ताह",
    day: "दिन",
    addNew: "नया जोड़ें",
    filterAll: "सभी",
    filterMedications: "दवाएं",
    filterLabTest: "लैब टेस्ट",
    filterDoctorAppointment: "डॉक्टर अपॉइंटमेंट",
    previousPeriod: "पिछली अवधि",
    nextPeriod: "अगली अवधि",
    addCalendarEvent: "कैलेंडर इवेंट जोड़ें",
  },
  pa: {
    title: "ਕੈਲੰਡਰ",
    today: "ਅੱਜ",
    month: "ਮਹੀਨਾ",
    week: "ਹਫ਼ਤਾ",
    day: "ਦਿਨ",
    addNew: "ਨਵਾਂ ਜੋੜੋ",
    filterAll: "ਸਾਰੇ",
    filterMedications: "ਦਵਾਈਆਂ",
    filterLabTest: "ਲੈਬ ਟੈਸਟ",
    filterDoctorAppointment: "ਡਾਕਟਰ ਅਪਾਇੰਟਮੈਂਟ",
    previousPeriod: "ਪਿਛਲੀ ਅਵਧੀ",
    nextPeriod: "ਅਗਲੀ ਅਵਧੀ",
    addCalendarEvent: "ਕੈਲੰਡਰ ਇਵੈਂਟ ਜੋੜੋ",
  },
  te: {
    title: "క్యాలెండర్",
    today: "ఈరోజు",
    month: "నెల",
    week: "వారం",
    day: "రోజు",
    addNew: "కొత్తది జోడించండి",
    filterAll: "అన్నీ",
    filterMedications: "మందులు",
    filterLabTest: "ల్యాబ్ టెస్ట్",
    filterDoctorAppointment: "డాక్టర్ అపాయింట్‌మెంట్",
    previousPeriod: "మునుపటి వ్యవధి",
    nextPeriod: "తదుపరి వ్యవధి",
    addCalendarEvent: "క్యాలెండర్ ఈవెంట్ జోడించండి",
  },
  ta: {
    title: "நாட்காட்டி",
    today: "இன்று",
    month: "மாதம்",
    week: "வாரம்",
    day: "நாள்",
    addNew: "புதியது சேர்",
    filterAll: "அனைத்தும்",
    filterMedications: "மருந்துகள்",
    filterLabTest: "ஆய்வக பரிசோதனை",
    filterDoctorAppointment: "மருத்துவர் சந்திப்பு",
    previousPeriod: "முந்தைய காலம்",
    nextPeriod: "அடுத்த காலம்",
    addCalendarEvent: "நாட்காட்டி நிகழ்வு சேர்",
  },
  mr: {
    title: "कॅलेंडर",
    today: "आज",
    month: "महिना",
    week: "आठवडा",
    day: "दिवस",
    addNew: "नवीन जोडा",
    filterAll: "सर्व",
    filterMedications: "औषधे",
    filterLabTest: "लॅब टेस्ट",
    filterDoctorAppointment: "डॉक्टर अपॉइंटमेंट",
    previousPeriod: "मागील कालावधी",
    nextPeriod: "पुढील कालावधी",
    addCalendarEvent: "कॅलेंडर इव्हेंट जोडा",
  },
  bn: {
    title: "ক্যালেন্ডার",
    today: "আজ",
    month: "মাস",
    week: "সপ্তাহ",
    day: "দিন",
    addNew: "নতুন যোগ করুন",
    filterAll: "সব",
    filterMedications: "ওষুধ",
    filterLabTest: "ল্যাব টেস্ট",
    filterDoctorAppointment: "ডাক্তার অ্যাপয়েন্টমেন্ট",
    previousPeriod: "পূর্ববর্তী সময়",
    nextPeriod: "পরবর্তী সময়",
    addCalendarEvent: "ক্যালেন্ডার ইভেন্ট যোগ করুন",
  },
  kn: {
    title: "ಕ್ಯಾಲೆಂಡರ್",
    today: "ಇಂದು",
    month: "ತಿಂಗಳು",
    week: "ವಾರ",
    day: "ದಿನ",
    addNew: "ಹೊಸದನ್ನು ಸೇರಿಸಿ",
    filterAll: "ಎಲ್ಲಾ",
    filterMedications: "ಔಷಧಿಗಳು",
    filterLabTest: "ಲ್ಯಾಬ್ ಪರೀಕ್ಷೆ",
    filterDoctorAppointment: "ವೈದ್ಯರ ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್",
    previousPeriod: "ಹಿಂದಿನ ಅವಧಿ",
    nextPeriod: "ಮುಂದಿನ ಅವಧಿ",
    addCalendarEvent: "ಕ್ಯಾಲೆಂಡರ್ ಈವೆಂಟ್ ಸೇರಿಸಿ",
  },
};

export const applyCalendarLocaleBlocks = (translations) => {
  if (!translations.en?.calendar) {
    translations.en.calendar = {
      title: "Calendar",
      today: "Today",
      month: "Month",
      week: "Week",
      day: "Day",
      addNew: "Add New",
      filterAll: "All",
      filterMedications: "Medications",
      filterLabTest: "Lab Test",
      filterDoctorAppointment: "Doctor Appointment",
      previousPeriod: "Previous period",
      nextPeriod: "Next period",
      addCalendarEvent: "Add Calendar Event",
    };
  }
  Object.entries(CALENDAR_LOCALE_BLOCKS).forEach(([lang, values]) => {
    if (!translations[lang]) return;
    translations[lang].calendar = {
      ...translations.en.calendar,
      ...translations[lang].calendar,
      ...values,
    };
  });
};
